// Decides when a visitor is sent to the LP's /failed page instead of seeing an inline error.

// Gateway verify-pin codes the visitor can simply retry (wrong / expired SMS code).
const RETRYABLE_VERIFY_CODES = new Set([2023, 2022]);

// verify-pin was rejected for a reason a retry won't fix (blocked, subscribe failed, backend down...).
// No code (e.g. the gateway could not be reached) keeps the inline error.
export function isFailedVerify(code) {
  if (code === null || code === undefined || code === '') return false;
  const numeric = Number(code);
  return Number.isFinite(numeric) && !RETRYABLE_VERIFY_CODES.has(numeric);
}

// A Beeline subscribe request that did not succeed, except "already subscribed", which stays inline.
export function isFailedSubscribe(result) {
  return !result?.success && !/already subscribed/i.test(result?.message ?? '');
}
